/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Total3WMarketCard from 'src/components/reports/reportsBoard/4wCards/Total3WMarketCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const Total3WMarketPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total mercado 3W"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <Total3WMarketCard
        titleCard="Evolución Total del Mercado 3W"
        g2Param="SUBCATEGORIA"
        table2Param="SUBCATEGORIA"
        arrayTable1={props.total}
        arrayG1={props.gtotal1}
        arrayTable2={props.totaSub}
        arrayG2A={props.totaS2A}
        arrayG2B={props.totaS2B}
        arrayTable3={props.totalC}
        arrayG3A={props.gtotalC3A}
        arrayG3B={props.gtotalC3B}
        selectedDate={selectedDate}
      />
      <Total3WMarketCard
        titleCard="Mercado CARGA- 3W"
        g2Param="SEGMENTO"
        table2Param="SEGMENTO"
        arrayTable1={props.totalS}
        arrayG1={props.gtotalS1}
        arrayTable2={props.totalSSub}
        arrayG2A={props.totalSS2A}
        arrayG2B={props.totalSS2B}
        arrayTable3={props.totalSC}
        arrayG3A={props.gtotalSC3A}
        arrayG3B={props.gtotalSC3B}
        selectedDate={selectedDate}
      />
      <Total3WMarketCard
        titleCard="Mercado PASAJEROS- 3W"
        g2Param="SEGMENTO"
        table2Param="SEGMENTO"
        arrayTable1={props.totalSP}
        arrayG1={props.gtotalS1P}
        arrayTable2={props.totalSSubP}
        arrayG2A={props.totalSS2AP}
        arrayG2B={props.totalSS2BP}
        arrayTable3={props.totalSCP}
        arrayG3A={props.gtotalSC3AP}
        arrayG3B={props.gtotalSC3BP}
        selectedDate={selectedDate}
      />
      <Total3WMarketCard
        titleCard="Mercado CARGA- MOTOCARRO SIN CABINA"
        g2Param="SEGMENTO"
        table2Param="SEGMENTO"
        disableG2
        arrayTable1={props.totalSCS}
        arrayG1={props.gtotalSC1}
        arrayTable3={props.totalSCSub}
        arrayG3A={props.gtotalSCS2A}
        arrayG3B={props.gtotalSCS2B}
        selectedDate={selectedDate}
      />
      <Total3WMarketCard
        titleCard="Mercado CARGA- MOTOCARRO CABINADO"
        g2Param="SEGMENTO"
        table2Param="SEGMENTO"
        disableG2
        arrayTable1={props.totalSCSC}
        arrayG1={props.gtotalSC1C}
        arrayTable3={props.totalSCSubC}
        arrayG3A={props.gtotalSCS2AC}
        arrayG3B={props.gtotalSCS2BC}
        selectedDate={selectedDate}
      />
    </>
  )
}

export default Total3WMarketPage
